module.exports = __webpack_public_path__ + "media/images/static/offer/lp_s01-ttl_s-a3cb3b844c5db8625ca66d4613b73e7f.png";